import {Component, Input, OnInit} from '@angular/core';
import {AdminService} from '../../../../../../services/admin.service';
import {ReviewSuggestionListsService} from '../../../services/review-suggestion-lists.service';
import {AnswerGroupPos} from '../../../../../admin/create-operating-standard/tree-group-pos-service/answer-group-pos.model';
import {SuggestionListsService} from '../../../services/suggestion-lists.service';
import {ActivatedRoute, Router} from '@angular/router';

@Component({
  selector: 'app-implementation-members',
  templateUrl: './implementation-members.component.html',
  styleUrls: ['./implementation-members.component.css']
})
export class ImplementationMembersComponent implements OnInit {

  @Input() users: any[] = [];
  @Input() error: boolean;
  @Input() towpath;
  @Input() iniciatorListId;
  isLoaded = false;
  errorMsg = false;
  allDivision: any[] = [];
  countOfDays = 2;
  selectedDivisions: any[] = [];
  toSend;
  responseMsg = '';
  showSuccessMsg = false;
  showErrorMsg = false;
  diableToPlanfixBtn = false;
  initiator;
  deputyPlanfixTasksGroups: any[] = [];
  nobodyPlanfixTasksGroups: any[] = [];
  notifyID:string;
  flag = false;

  constructor(private adminService: AdminService,
              private route: ActivatedRoute,
              private router: Router,
              public suggestionListsService: SuggestionListsService,
              public reviewSuggestionListsService: ReviewSuggestionListsService) {
  }

  ngOnInit() {
    this.users.sort((a, b) => a.lastName.localeCompare(b.lastName));
    this.notifyID = this.route.snapshot.params['notifyId'];
    for (var i = 0; i < this.users.length; i++) {
      if (this.users[i].id === this.iniciatorListId) {
        this.flag = true;
        break;
      }
    }
    
    if(this.users) {
      this.initiator = this.users[0].id;
    }
    this.responseMsg = '';
    this.showSuccessMsg = false;
    this.showErrorMsg = false;
    this.diableToPlanfixBtn = false;

    this.suggestionListsService.firstDisableService = false;

    this.deputyPlanfixTasksGroups = [];
    this.nobodyPlanfixTasksGroups = [];
    this.suggestionListsService.setDeputyPlanfixTasksGroups(this.deputyPlanfixTasksGroups);
    this.suggestionListsService.setNobodyPlanfixTasksGroups(this.nobodyPlanfixTasksGroups);

    this.isLoaded = false;
    this.adminService.getAllGroupsHeadPlanfix().subscribe(
      // this.adminService.getAllGroups().subscribe(
      (res: any) => {
        if (res.status === 200) {
          const divisionsFromAPI = res.body;
          divisionsFromAPI.forEach(division => {
            this.allDivision.push(
              {
                division: division,
                taskDesc: '',
                isChecked: false,
                placeHolder: ''
              }
            );
          });

          this.isLoaded = true;
        }
      },
      () => {
        this.isLoaded = true;
      }
    );
  }


  isDivisionSelected(division) {
    return this.selectedDivisions.includes(division);
  }

  fieldsChangeDivision(values: any, division) {
    if (values.currentTarget.checked) {
      // CHECK
      division.isChecked = true;
      // Placeholder
      if (division.taskDesc.trim().length < 1) {
        division.placeHolder = 'Add task description...';
      }
      // Add division to selected list
      if (!this.isDivisionSelected(division)) {
        this.selectedDivisions.push(division);
      }

    } else {
      // UNCHECK
      division.isChecked = false;

      if (division.taskDesc.trim().length < 1) {
        division.placeHolder = '';
      }

      // Remove division from selected list
      if (this.isDivisionSelected(division)) {
        const index = this.selectedDivisions.indexOf(division);
        this.selectedDivisions.splice(index, 1);
      }

    }

    this.responseMsg = '';
    this.showSuccessMsg = false;
    this.showErrorMsg = false;

  }

  changeTextArea(division) {
    if (division.taskDesc.trim().length > 0) {
      if (!division.isChecked) {
        division.isChecked = true;

        // Add division to selected list
        if (!this.isDivisionSelected(division)) {
          this.selectedDivisions.push(division);
        }
      }
    } else {
      if (division.isChecked) {
        division.isChecked = false;

        // Remove division from selected list
        if (this.isDivisionSelected(division)) {
          const index = this.selectedDivisions.indexOf(division);
          this.selectedDivisions.splice(index, 1);
        }

      }
      // Clear placeholder
      division.placeHolder = '';
    }

    this.responseMsg = '';
    this.showSuccessMsg = false;
    this.showErrorMsg = false;

  }

  makeFieldsDisabled() {
    // Is disabled by default
    let dis = false;
    if (this.selectedDivisions.length > 0) {
      this.selectedDivisions.forEach(sd => {
        if (sd.taskDesc.trim().length < 1) {
          dis = true;
        }
      });
    } else {
      // Make disabled
      dis = true;
    }
    return dis;
  }

  setInitiator(login: string): void {
		this.initiator = this.users.find(value => value.login === login).id;
	}

  markNotify(itemId) {
    const sendingParams = {
      id: itemId,
      notificationCategory: "SUGGESTION"
    };
    this.adminService.notifyIsView(sendingParams).subscribe(
      (response: any) => { },
      () => {
      }
    );
  }

  createPlanfixTasks() {
    this.responseMsg = '';
    this.showSuccessMsg = false;
    this.showErrorMsg = false;
    this.diableToPlanfixBtn = true;

    const headsTasks: any[] = [];



    if(this.error) {
      if(this.flag) {
        this.toSend = {
          slId: this.reviewSuggestionListsService.getOpenedSLID(),
          taskDeadline: this.countOfDays,
          userId: this.towpath.id,
          groupId: this.selectedDivisions[0].division.id,
          taskDescription: this.selectedDivisions[0].taskDesc
        }
      } else {
        this.toSend = {
          slId: this.reviewSuggestionListsService.getOpenedSLID(),
          taskDeadline: this.countOfDays,
          userId: this.initiator,
          groupId: this.selectedDivisions[0].division.id,
          taskDescription: this.selectedDivisions[0].taskDesc
        }
      }
    } else {
      this.selectedDivisions.forEach(d => {
        if (d.division.headId !== null && d.division.headId !== undefined) {
  
          this.toSend = {
            slId: this.reviewSuggestionListsService.getOpenedSLID(),
            taskDeadline: this.countOfDays,
            userId: this.initiator,
            groupId: d.division.id,
            taskDescription: d.taskDesc
          };
  
        } else {
          this.nobodyPlanfixTasksGroups.push(d);
        }
        this.suggestionListsService.setNobodyPlanfixTasksGroups(this.nobodyPlanfixTasksGroups);
      });
    }
   
    this.suggestionListsService.sendToPlanfix(this.toSend).subscribe(
      (res: any) => {
        if (res.status === 200 || res.status === 201 || res.status === 204) {
          // Show messages
          if (this.router.url.includes('ex-suggestion-expired')) {
            this.markNotify(this.notifyID);
            this.responseMsg = 'Request was successfully sent!';
            this.showSuccessMsg = true;
            this.showErrorMsg = false;
            this.diableToPlanfixBtn = false;
            this.suggestionListsService.firstDisableService = true;
            this.suggestionListsService.showSuccessMsgForReviewList = true;
            this.router.navigate(['/ex-notifications']);
          } else {
            this.responseMsg = 'Request was successfully sent!';
            this.showSuccessMsg = true;
            this.showErrorMsg = false;
            this.diableToPlanfixBtn = false;
            this.suggestionListsService.firstDisableService = true;
            this.suggestionListsService.showSuccessMsgForReviewList = true;
            this.router.navigate(['/dashboard/my-suggestion-lists/my-lists']);
          }
        } else {
          // Show messages
          this.responseMsg = 'Error sending a request to create tasks in PlanFix for the Heads of the selected Divisions.';
          this.showSuccessMsg = false;
          this.showErrorMsg = true;
          this.diableToPlanfixBtn = false;
        }
      },
      () => {
        // Show messages
        this.responseMsg = 'Error sending a request to create tasks in PlanFix for the Heads of the selected Divisions.';
        this.showSuccessMsg = false;
        this.showErrorMsg = true;
        this.diableToPlanfixBtn = false;
      }
    );
  }

}



// WEBPACK FOOTER //
// C:/work/new2/internal-frontend/src/app/content-page/common/suggestion-lists/components/view-suggestion-list/implementation-members/implementation-members.component.ts